"use strict";exports.isBrowser=function(){return"undefined"!=typeof window};
//# sourceMappingURL=isBrowser-60045f2d.js.map
